var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "o-button",
    {
      attrs: { variant: "primary", size: "md", "native-type": "submit" },
      on: {
        click: function () {
          return _vm.emit("handleSubmit")
        },
      },
    },
    [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }